import "./sw-donate.module.css";
import { html } from "lit-html";
import { LANGUAGE } from "../../global.ts";
import Strings from "../../../models/Strings.json";

export default (user) => html`
    <div
        id="sw-donate"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3 class="text-base md:text-xl font-semibold text-theme">
                        ${Strings.donateTitle[LANGUAGE]}
                    </h3>
                    <button
                        title="${Strings.close[LANGUAGE]}"
                        type="button"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                        data-modal-hide="sw-donate">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">${Strings.close[LANGUAGE]}</span>
                    </button>
                </div>
                <!-- Modal body -->
                <div
                    class="p-4 md:p-5 space-y-4 text-base leading-[2] text-gray-900 dark:text-white">
                    ${LANGUAGE === "khmer"
                        ? html`<p>
                                  យើងខ្ញុំសូមអំពាវនាវដល់សប្បុរសជនគ្រប់លំដាប់ថ្នាក់
                                  មេត្តាជួយគាំទ្រគំរោងព្រះត្រៃបិដកអេអាយអនឡាញឲ្យមានគុណភាព
                                  និងប្រសិទ្ធិភាពខ្ពស់
                                  ដោយផ្តល់នូវការបរិច្ចាគឧបត្ថម្ភ
                                  ដល់ក្រុមយើងខ្ញុំតាមកម្លាំង និងសទ្ធា។
                              </p>
                              <p>
                                  ការបរិច្ចាគឧបត្ថម្ភរបស់អ្នក
                                  គឺជាការជួយធ្វើឲ្យផ្នែកព្រះពុទ្ធសាសនាមានការផ្សព្វផ្សាយទូលំទូលាយ
                                  ទៅដល់ពុទ្ធសាសនិកនៅក្នុងព្រះរាជាណាចក្រកម្ពុជា
                                  និងបរទេស ។ មិនត្រឹមប៉ុណ្ណោះទេ
                                  ថែមទាំងជួយការអភិវឌ្ឍន៍តាមបណ្តាញ​អេអាយ​អ​នឡានឲ្យល្អប្រសើរ
                                  និងជួយឲ្យក្រុមយើងខ្ញុំ មានកម្លាំចិត្ត
                                  និងលទ្ធភាពអាចទិញឧបករណ៍បច្ចេកវិទ្យាអេឡិចត្រូនិចផ្សេងៗ
                                  ដើម្បីយកមកប្រើប្រាសក្នុងគំរោង​​ឲ្យ​កាន់តែល្អ​​ទំនើប​និង​ទាន់​សម័យជាង​មុន​។
                              </p>
                              <p>
                                  ការចូលរួមបរិច្ចាគរបស់អ្នក
                                  គឺជាធម្មទានដ៏ល្អបំផុត
                                  និងជាទានឈ្នះអស់ទានទាំងពួង
                                  ព្រោះការចូលរួមរបស់អ្នក​ជាការចែករំលែកព្រះធម៌ដែលព្រះសម្មាសម្ពុទ្ធបានសម្តែង
                                  ដល់អ្នកកំពុងចង់ដឹង ចង់ចេះ និងចង់យល់ពីធម៌។
                              </p>
                              <p>
                                  ក្រុមយើងខ្ញុំ សូមថ្លែងអំណរគុណដ៏ជ្រាលជ្រៅបំផុត
                                  ដល់ការចូលរួមចំណែក
                                  ក្នុងការធ្វើឲ្យគំរោងអេអាយអនឡាញនេះ
                                  ទទួលបានជោគជ័យ។
                              </p>`
                        : html`<p>
                                  We sincerely appeal to all generous
                                  individuals to support our online AI Tipitaka
                                  project in improving its quality and
                                  effectiveness by providing donations to our
                                  team according to your means and faith.
                              </p>
                              <p>
                                  Your contributions will not only help enhance
                                  the development of our online platform but
                                  also empower our team with the resources and
                                  ability to acquire advanced technological
                                  equipment to implement and operate the project
                                  more effectively and in line with modern
                                  digital AI advancements.
                              </p>
                              <p>
                                  Your participation in this donation is the
                                  most virtuous act of giving and the ultimate
                                  form of generosity, as it reflects the sharing
                                  of the Dhamma that the Buddha has taught to
                                  those seeking knowledge and understanding of
                                  the truth.
                              </p>
                              <p>
                                  Our team would like to express our deepest
                                  gratitude for your participation in making
                                  this online AI project a success.
                              </p>`}
                </div>
                <!-- Modal footer -->
                <div
                    class="flex items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button
                        onclick="heartbank.alertAdmin('donate/click/${Strings
                            .donate2[LANGUAGE]}')"
                        id="sw-donate-cash"
                        type="button"
                        class="text-white w-32 bg-hb hover:bg-hb/25 focus:ring-4 focus:outline-none focus:ring-hb/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-hb dark:hover:bg-hb/50 dark:focus:ring-hb/10">
                        ${Strings.donate2[LANGUAGE]}
                    </button>
                    <a
                        onclick="heartbank.alertAdmin('donate/click/${Strings
                            .donate1[LANGUAGE]}')"
                        href="https://donate.stripe.com/aEU4h37GsfgufBK6oo?locale=km&prefilled_promo_code=333&client_reference_id=${user
                            ? user.uid
                            : ""}&prefilled_email=${user
                            ? encodeURIComponent(user.email)
                            : ""}"
                        target="_blank"
                        data-modal-hide2="sw-donate"
                        type="button"
                        class="text-white w-32 bg-hb hover:bg-hb/25 focus:ring-4 focus:outline-none focus:ring-hb/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-hb dark:hover:bg-hb/50 dark:focus:ring-hb/10">
                        ${Strings.donate1[LANGUAGE]}
                    </a>
                    <button
                        data-modal-hide="sw-donate"
                        type="button"
                        class="hidden text-white w-24 bg-hb hover:bg-hb/25 focus:ring-4 focus:outline-none focus:ring-hb/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-hb dark:hover:bg-hb/50 dark:focus:ring-hb/10">
                        ${Strings.close[LANGUAGE]}
                    </button>
                </div>
                <section
                    class="w-full my-3 pb-2 inline-flex items-center justify-center">
                    <aside
                        id="sw-donate-hb"
                        onclick="heartbank.alertAdmin('donate/click/heartbank')"
                        class="cursor-pointer moul self-end text-base font-extralight whitespace-nowrap text-gray-500 dark:text-gray-400">
                        Heart
                        <svg
                            class="mt-[-4px] ml-[-8px] mr-[-4px] inline fill-hb"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="25"
                            height="25">
                            <path
                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                transform="rotate(45 12 12)" />
                        </svg>
                        ank<sup>®</sup>
                    </aside>
                </section>
            </div>
        </div>
    </div>
`;
